import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 — Page Not Found | Chiller Fleet Transport</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="container-fluid py-5" style={{ minHeight: "60vh", display: "flex", alignItems: "center" }}>
        <div className="container text-center py-5">
          <h1 className="h1-title mb-3">404</h1>
          <h2 className="h2-title mb-4">Page Not Found</h2>
          <p className="mb-4 mx-auto" style={{ fontSize: "1.6rem", color: "#555", maxWidth: "560px" }}>
            The page you're looking for doesn't exist or may have been moved. Try one of the links below to find your way back.
          </p>
          <div className="d-flex flex-wrap justify-content-center gap-3">
            <Link to="/" className="mini-btn primary">Back to Home</Link>
            <Link to="/services" className="mini-btn secondary">View Services</Link>
            <Link to="/contact-us" className="mini-btn secondary">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
